import { RecommendedDistribution } from '../../models/rest/sizing';
import { Distribution, DistributionType } from '../../models/sizing';

export function mapRestDistributionType(type: string): DistributionType {
  switch (type) {
    case 'RECOMMENDED':
      return DistributionType.RECOMMENDED;
    case 'FALLBACK':
      return DistributionType.FALLBACK;
    case 'SILO':
      return DistributionType.SILO;
    default:
      return DistributionType.UNKNOWN;
  }
}

export function mapRestDistributionToStore(
  restDist: RecommendedDistribution | null | undefined
): { distribution: Distribution; distributionType: DistributionType; recoStrategy: string; recoLevel: string } | null {
  if (!restDist) return null;
  return {
    distribution: restDist.distribution_map,
    distributionType: mapRestDistributionType(restDist.distribution_type),
    recoStrategy: restDist.strategy,
    recoLevel: restDist.level,
  };
}
